import React from 'react';
import './Something.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
const Something = () => {
    return (
        <div className="something">
            <div className="wrapper">
               <div className="container">
               <div className="section-title something-t">
                    <h2>কিছু কথা</h2>
                </div>
                <div className="section-body">
                    <p className="mb-4">
                    স্কয়ারফিটের সংস্কৃতিতে যেন আটকে পড়েছে আমাদের শিশুরা। আবদ্ধ জীবন। মাঠের খেলা ফুটবল ক্রিকেট সেটাও খেলছে মোবাইলে। বাস্তবতা মা-বাবা দুই জনকেই চাকুরি করতে বাধ্য করছে। কিন্তু যাদের জন্য এত পরিশ্রম সেই সন্তানদের কেই সময় দেওয়া সম্ভব হচ্ছে না। স্নেহময়ী মায়ের অনুসন্ধিৎসু মন যেন সবসময় জানতে চাই আমার বাচ্চার ওজন,উচ্চতা,বিএমআই,মানসিক বিকাশ সব ঠিকমতো বাড়ছে তো? তার দৈনন্দিন খাবারের মেন্যুতে সব পুষ্টি থাকছে তো? বাচ্চা একেবারেই খেতে চাচ্ছে না, দিন দিন শুকিয়ে যাচ্ছে আর খাবার খাওয়া না খাওয়া নিয়ে যুদ্ধ যেন মায়ের টেনশনের পারদ বাড়িয়ে দিচ্ছে প্রতিনিয়ত। এটা থেকে মুক্তির উপায় কী? এছাড়া ও -----
                    </p>
                    <ul>
                        <li>
                            <FontAwesomeIcon className="arrowIcon" icon={faAngleDoubleRight} />
                            &nbsp;
                            <span>
                            ছয় মাস বয়স শেষ হবার পর মায়েরা চিন্তিত থাকেন তার সোনামণিকে বাড়তি খাবার বা <span className="english-font">complementary feeding</span> কি দিবেন অথবা বাড়ন্ত শিশু/ স্কুল পড়ুয়া শিশুর নিউট্রিশনাল প্লানটাও বা কী হবে?
                            </span>
                        </li>
                        <li>
                            <FontAwesomeIcon className="arrowIcon" icon={faAngleDoubleRight} />
                            &nbsp;
                            <span>
                            ছয় মাস বয়স শেষ হবার পর মায়েরা চিন্তিত থাকেন তার সোনামণিকে বাড়তি খাবার বা <span className="english-font">complementary feeding</span> কি দিবেন অথবা বাড়ন্ত শিশু/ স্কুল পড়ুয়া শিশুর নিউট্রিশনাল প্লানটাও বা কী হবে?
                            </span>
                        </li>
                        <li>
                            <FontAwesomeIcon className="arrowIcon" icon={faAngleDoubleRight} />
                            &nbsp;
                            <span>
                            অতিরিক্ত মোটা বা <span className="english-font">childhood obesity</span> অথবা অপুষ্টিতে ভোগা শিশুর ডায়েট প্লানটাও বা কি হবে?
                            </span>
                        </li>
                        <li>
                            <FontAwesomeIcon className="arrowIcon" icon={faAngleDoubleRight} />
                            &nbsp;
                            <span>
                            অটিস্টিক শিশু <span className="english-font">/ADHD/</span> অতি অস্হির শিশুর খাদ্য পরামর্শ।
                            </span>
                        </li>
                        <li>
                            <FontAwesomeIcon className="arrowIcon" icon={faAngleDoubleRight} />
                            &nbsp;
                            <span>
                            শিশুদের বিভিন্ন হরমোনাল সমস্যা যেমন: ডায়াবেটিস বা থাইরয়েড সমস্যার খাদ্য তালিকা প্রণয়ন।
                            </span>
                        </li>
                        <li>
                            <FontAwesomeIcon className="arrowIcon" icon={faAngleDoubleRight} />
                            &nbsp;
                            <span>
                            এছাড়াও শিশুর মেধা বিকাশ,ওজন,উচ্চতা বৃদ্ধির ডায়েট,হাড়ের সমস্যা, <span className="english-font">Blood disorders</span> যেমন- থ্যালাসেমিয়ার কারনে রক্তশূন্যতা পূরণের ডায়েট, গ্যাস্ট্রিকেরসমস্যা, ক্রনিক ডায়রিয়া, ডিসেন্ট্রি, কোষ্ঠকাঠিন্য, পেট ব্যথা, খাবারের পরেই বমি, খাদ্য এলার্জী, দীর্ঘ মেয়াদি জ্বর, জন্ডিস, জেনেটিক সমস্যা যেমন- <span className="english-font">DOWN syndrome,</span> মেটাবলিক সমস্যা- <span className="english-font">Wilson's disease, Phenylketonuria, Rickets, Galactosemia</span> অথবা কিডনি ডিজিসসহ শিশুদের সকল রোগের চিকিৎসা সমন্বিত নিউট্রিশনাল/ডায়েট প্লান দেবার জন্য ডাক্তার হাবিবুর রহমান স্যার আছেন আপনার পাশে সবসময়।
                            </span>
                        </li>
                    </ul>
                    <p className="mt-4">ভাল থাকুক, সুস্থ্য থাকুক আমাদের সোনামনিরা।স্বাস্থ্যবান ও মেধাবী শিশুতে ভরে উঠুক আমাদের প্রতিটি ঘর।</p>
                </div>
               </div>
            </div>
            
        </div>
    );
};

export default Something;